import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, Typography, Snackbar } from '@mui/material'
import { Swiper, SwiperSlide } from 'swiper/react';
import Cookies from 'js-cookie';
import Button from '@mui/material/Button';
import Header from "../header/Header";
import HeroSection from "../hero-section/HeroSection";
import FooterSection from "../footer/FooterSection";
import SubTopHead from "../sub-top-head/SubTopHead";
import VideoThumbnail from 'react-video-thumbnail';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


// import required modules
import { Pagination, Navigation } from "swiper";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import "../../App.css";
import "../subject/Subject.css";
import "../session-list/SessionList.css";
import "../responsive/Responsive.css";
import crossBtn from '../../assets/images/close.svg';

import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import useSocket from '../../custom-hooks/useSocket';
import useTranslations from '../../custom-hooks/useTranslations';
import useStudentDashboard from '../../custom-hooks/useStudentDashboard';
import { addToFavtTutor } from '../../actions/addToFavtTutorAction';
import { submitFeedBack } from '../../actions/submitFeedBackAction';
import generateAgoraToken from '../../services/AgoraTokenService';
import { encryptData } from '../../services/encryptDecrypt';
import { API_BASE_URL, WebSocketURL } from '../../config/apiConfig';
import { axiosPost } from '../../services/api';
import momentDate from '../../services/momentDate';
import timeAgoDate from '../../services/timeAgoDate';

import MessageModal from '../common-components/MessageModal';
import ImageCropModal from '../common-components/ImageCropModal';
import Advertisement from '../common-components/Advertisement';
import QuickCallModal from '../common-components/QuickCallModal';
import FeedbackModal from '../common-components/FeedbackModal';
import HireTutorModal from '../common-components/HireTutorModal';
import { openMessageModal } from '../../actions/modalAction';
import AskNowTutorModal from '../common-components/AskNowTutorModal';

const QuickCall = () => {
    const dispatch = useDispatch();
	const navigate = useNavigate();
    const [isAskNow, setIsAskNow] = useState(false);
    const [tutorInfo, setTutorInfo] = useState({});
	const translations = useTranslations();
	const { isConnected, socket } = useSocket();
    const { studentDashboard, addSessionRating, markAsFavTutor } = useStudentDashboard();
	const [selectedTopic, setSelectedTopic] = useState(null);
	const [selectedSubtopic, setSelectedSubtopic] = useState(null);
	const [openQCModal, setOpenQCModal] = useState(false);
    const [openHTModal, setOpenHTModal] = useState(false);
    const [openHTModal1, setOpenHTModal1] = useState(false);
	const [imageUrl, setImageUrl] = useState('');
	const [question, setQuestion] = useState("");
	const [topics, setTopics] = useState([]);
	const [showTopics, setShowTopics] = useState(false);
	const [showSubTopics, setShowSubTopics] = useState(false);
	const [disableConnect, setDisableConnect] = useState(true);
	const [topicName, setTopicName] = useState();
	const [favouriteTutor, setFavouriteTutor] = useState({});    
    const [feedbackModal, setFeedbackModal] = useState(sessionStorage.getItem('StudentSessionEnd') ? true : false);
    const [sessionFeedBack, setSessionFeedBack] = useState({
        TutorRating: '',
        FeedbackMessage: []
    });
    const [file, setFile] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isCropImageModal, setIsCropImageModal] = useState(false);
    const [session, setSession] = useState({});
    const [isApiCalling, setIsApiCalling] = useState(false);
    const [QuestionID, setQuestionID] = useState(null);
    const [isConecting, setIsConecting] = useState(false);
    const [socketConnected, setSocketConnected] = useState(false);
    
    const translation = {
        ...translations[7]?.PersonalInfo,
        ...translations[8]?.PrivateClassDashboard,
        ...translations[18]?.YourCourses,
        ...translations[21]?.CommonFrontend,
        ...translations[23]?.TutorRegistration,
        ...translations[26]?.QuickCall,
        ...translations[29]?.FindTutor,
        ...translations[31]?.Wallet,
    }

    const user = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
    const profileInfo = Cookies.get("ProfileInfo") ? JSON.parse(Cookies.get("ProfileInfo")): null;
    const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
	const studentProfile = useSelector(({ studentProfileReducer }) => studentProfileReducer.student[0]) || Cookies.get("ProfileInfo") ? JSON.parse(Cookies.get("ProfileInfo")): null;
    const boards = useSelector(({ examBoardsReducer }) => examBoardsReducer?.boards);
    const isMessage = useSelector(({ modalReducer }) => modalReducer.isMessage);

    const viewTutorProfile = (tutorId) => {
		navigate(`/tutor-profile/${btoa(tutorId)}`);
	}

    const viewSessionList = () => {
        navigate('/session-list')
    }

    const viewSessionDetail = (session) => {
        navigate(`/session-detail/${btoa('RS' + session?.ID)}/${btoa(session?.TutorID)}`)
    }

    const handleFavouriteTutor = (session) => {
		markAsFavTutor(session?.TutorID );
        dispatch(addToFavtTutor({ TutorID: session?.TutorID }));
	}

    const handleSessionRating = (session) => {
        setFeedbackModal(true)
        setSession(session);
    }

    const onChangeFeedback = (name, value) => {
        setSessionFeedBack((prev) => {
          if (name === 'FeedbackMessage') {
            const updatedFeedBack = prev?.FeedbackMessage?.includes(value)
              ? prev.FeedbackMessage.filter((item) => item !== value)
              : [...prev.FeedbackMessage, value];
      
            return {
              ...prev,
              FeedbackMessage: updatedFeedBack,
            };
          }
      
          return {
            ...prev,
            [name]: value,
          };
        });
    };
      

    const onSubmitFeedback = async (e) => {
        try {
            sessionStorage.removeItem('StudentSessionEnd');
            const questionId = sessionStorage.getItem('QuestionID');
            setFeedbackModal(false);
    
            if (questionId || session.Type === 'QC') {
                const sessionId = questionId || session?.ID;
                const data = {
                    SessionID: sessionId,
                    TutorRating: sessionFeedBack.TutorRating,
                    SessionFeedbackMsg: sessionFeedBack.FeedbackMessage
                }
                addSessionRating(sessionId, sessionFeedBack.TutorRating);
                dispatch(submitFeedBack(data))
            } else {
                const sessionId = sessionStorage.getItem("SessionID") || session?.ID;
                const data = {
                    SessionID: sessionId,
                    Ratings: sessionFeedBack.TutorRating,
                    FeedbackID: sessionFeedBack.FeedbackMessage
                };
                addSessionRating(sessionId, sessionFeedBack.TutorRating);
                await axiosPost(`${API_BASE_URL}/SavePrivateTutorFeedback`, data);
            }
            setSessionFeedBack({
                TutorRating: '',
                FeedbackMessage: []
            });
            // dispatch(getStudentDashBoard());
            sessionStorage.removeItem("StudentRequest");
            sessionStorage.removeItem("TutorResponse");
            sessionStorage.removeItem("QuestionID");
            sessionStorage.removeItem("SessionID");
            localStorage.removeItem("CallDuration");
            localStorage.removeItem("CallType");
        } catch (error) {
			console.error('An error occurred while saving feedback:', error);
		}
	}

	const handleTopicClick = (topicID, topic) => {
		setTopicName(topic.Value);
		setSelectedTopic(topicID);
		if (topic?.SubTopics?.length === 0) {
			setShowSubTopics(false)
			setDisableConnect(false);
		} else {
            setSelectedSubtopic(null);
			setShowSubTopics(true);
			setDisableConnect(true);
		}
	};

	const handleSubtopicClick = (subtopicID) => {
		setSelectedSubtopic(subtopicID);
		setDisableConnect(false);
	};

	const handleConnectWithTutor = ( retryQuestionID = 0) => {
        sessionStorage.setItem('CallRequestType', "QuickCall");
        setOpenQCModal(true);
        setIsApiCalling(true);
		const payload = {
			QuestionID: retryQuestionID ,
			SubjectID: selectedTopic.toString(),
			SubTopicID: selectedSubtopic.toString(),
			SubjectName: topicName,
			Notes: question,
			ImageURL: imageUrl,
			StudentID: studentProfile?.ID,
			StudentName: studentProfile?.UserName,
			StudentImage: studentProfile?.ProfilePictureUrl,
			StudentClass: studentProfile?.Grade,
			StudentClassID: studentProfile?.StudentGradeID.toString(),
			TutorID: "",
			TutorName: "",
			TutorImage: "",
			TutorSubject: "",
			EnglishMessage: "",
			ArabicMessage: "",
			requestType: "1",
			ReasonID: "",
			IsAccept: false,
			IsDecline: false,
            CallType: 0,
            IsJoin: false,
		}

		const stringifiedObj = JSON.stringify(payload);
        
		socket.emit("QCQuestions", stringifiedObj, 'QC');
	};

	const cancelQuickCall = (event, reason) => {
		if (reason && reason === "backdropClick" && "escapeKeyDown") {
			return;
		}
		setOpenQCModal(false);
		cancelQCRequest();
	};

    const cancelQCRequest = () => { 
        console.log("check4");
        const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));

        if (!isConnected) {
            console.error('Socket is not connected. Unable to cancel request.');
            return;
        }

        if (studentRequest) {
            studentRequest.IsDecline = true;
            studentRequest.requestType = "1";
            console.log("studentRequestQuickCall", studentRequest);
            socket.emit("QCQuestions", JSON.stringify(studentRequest), 'QC');        
            sessionStorage.removeItem("TutorResponse");
            sessionStorage.removeItem("StudentRequest");
            sessionStorage.removeItem("CallRequestType");
            socket?.off('GetOnlineTutorResponseEvent');
        }
    };


    const handleAskNowTutor = ( retryQuestionID = 0) => {
        sessionStorage.setItem('CallRequestType', "QuickCall");        
        setOpenHTModal1(true);
        setIsApiCalling(true);
		const payload = {
			QuestionID: retryQuestionID ,
			SubjectID: selectedTopic.toString(),
			SubTopicID: selectedSubtopic.toString(),
			SubjectName: topicName,
			Notes: question,
			ImageURL: imageUrl,
			StudentID: studentProfile?.ID,
			StudentName: studentProfile?.UserName,
			StudentImage: studentProfile?.ProfilePictureUrl,
			StudentClass: studentProfile?.Grade,
			StudentClassID: studentProfile?.StudentGradeID.toString(),
			TutorID: tutorInfo?.ID,
			TutorName: tutorInfo?.UserName,
			TutorImage: tutorInfo?.ProfilePictureUrl,
			TutorSubject: tutorInfo?.Topics[0],
			EnglishMessage: "",
			ArabicMessage: "",
			requestType: "1",
			ReasonID: "",
			IsAccept: false,
			IsDecline: false,
            CallType: 1,
            IsJoin: false
		}

		const stringifiedObj = JSON.stringify(payload);
        sessionStorage.setItem('StudentRequest', JSON.stringify(payload));
		socket.emit("DirectQCQuestion", stringifiedObj);
	};

    const cancelAskNowRequest = () => {              
        const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
        setOpenHTModal1(false);
		if (!socket || !socket.connected) {
			// If socket is not initialized or not connected, do not emit the event
			console.error('Socket is not connected. Unable to cancel request.');
			return;
		}
        if(studentRequest){
            studentRequest.IsDecline = true;
            studentRequest.requestType = "1";
            setTimeout(() => {     
                console.log("studentRequestQuickCall" , studentRequest);
                console.log("studentRequestQuickCall>>>");
                socket.emit("DirectQCQuestion", JSON.stringify(studentRequest));        
                sessionStorage.removeItem("TutorResponse")
                sessionStorage.removeItem("StudentRequest")
                sessionStorage.removeItem("CallRequestType")
            }, 4000);
        }
	};


    
	const OnChangeHandler = (e) => {
        const sanitizedValue = e.target.value.replace(/\s+/g, ' '); // Replace multiple spaces with a single space
        setQuestion(sanitizedValue.trim());
	}

	const onContinuehandler = () => {
		setShowTopics(true);
	}

    const onSubmitCroppedImage = async () => {
        setIsApiCalling(true);
        const response = await fetch(file);
        const blob = await response.blob();
        const croppedImage = new File([blob], `Question${Date.now()}.jpg`, { type: 'image/jpeg' });

        const formData = new FormData();
        formData.append('image', croppedImage);
        formData.append('fileType', 'QuickCallImage');

        try {
            const webSocketURL = localStorage.getItem('WebSocketURL');
            const response = await axiosPost(`${webSocketURL}/FileUpload`, formData, {  
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
                },
            });
            if (response.data) {
                setIsApiCalling(false);
                setShowTopics(true);
                setIsCropImageModal(false);
                setImageUrl(response.data?.FileUpload);
            }
        } catch (error) {
            setIsApiCalling(false);
            console.error('Error uploading image:', error);
        }
    }

    const handleFileSelect = (event) => {
		const selectedFile = event.target.files[0];
        if (!selectedFile) return;

        const fileSizeInMB = selectedFile.size / 1024 / 1024; // Convert size to MB

        if (fileSizeInMB > 1) {
          setSnackbarOpen(true);
          setFile(null); // Clear the file URL in the state
          return;
        }
        setFile(URL.createObjectURL(selectedFile))
        setIsCropImageModal(true);
        event.target.value = null; // Clear the file input
	}

    const handleDragOver = (event) => {
		event.preventDefault();
	};

	const handleDrop = (event) => {
		event.preventDefault();
		const selectedFile = event?.dataTransfer.files[0];
        if (!selectedFile) return

        const fileSizeInMB = selectedFile.size / 1024 / 1024; // Convert size to MB

        if (fileSizeInMB > 1) {
          setSnackbarOpen(true);
          setFile(null); // Clear the file URL in the state
          return;
        }
		setFile(URL.createObjectURL(selectedFile));
        setIsCropImageModal(true);
        event.target.value = null; // Clear the file input
	}

	const handleRemoveImage = () => {
		setImageUrl("");
		setShowTopics(false);
		setShowSubTopics(false);
		setDisableConnect(true);
		setSelectedTopic(null);
		setSelectedSubtopic(null);
	};

    const cancelCropImage = () => {
        isApiCalling && setIsApiCalling(false);
        setIsCropImageModal(false);
        setFile(null);
    }

    const onConnectFavTutor = (tutor) => {
        try {
            if (isConnected) {
                setOpenHTModal(true);
                const payload = {};
                payload['EndPoint'] = '/TutorRequest';
                // payload['DeviceID'] = sessionStorage.getItem('deviceId');
                payload['DeviceID'] = Cookies.get('deviceId');
                payload['authorization'] = Cookies.get('loginToken') ? JSON.parse(Cookies.get('loginToken'))?.idToken : null;
                payload['StudentID'] = studentProfile?.ID;
                payload['StudentName'] = studentProfile?.UserName;
                payload['StudentClass'] = studentProfile?.Grade;
                payload['StudentClassID'] = studentProfile?.StudentGradeID.toString();
                payload['StudentImage'] = studentProfile?.ProfilePictureUrl;
                payload['TopicName'] = topics?.map(topic => topic.Value).join(',') || '';
                payload['IsDecline'] = false;
                payload['IsAccept'] = false;
                payload['TutorID'] = parseInt(tutor?.ID);
                payload['langid'] = localStorage.getItem('langId');
                payload['requestType'] = 1; // student = 1 tutor= 2
                payload['TutorName'] = tutor?.UserName;
                payload['TutorImage'] = tutor?.ProfilePictureUrl;
                payload['TutorRating'] = tutor?.Rating;
                payload['Price'] = tutor?.Price;
                payload['TutorPrice'] = tutor?.TutorPrice;
                payload['CurrencyType'] = tutor.CurrencyType;
                payload['TutorTotalSesssion'] = Number(tutor?.SessionCount);
                payload['isPaymentDone'] = 0; // default = 0  success =2  failed =3 // after payment
                payload['SessionID'] = 0; 
                payload['IsFavCall'] = true;

                sessionStorage.setItem('StudentRequest', JSON.stringify(payload));
                socket.emit('PTModule', JSON.stringify(payload));
            }
        
        } catch (error) {
            console.log('error');
        }
	}

    const askNow = (tutor) => {
        setIsAskNow(true);
        setTutorInfo(tutor)
    }



    const cancelFavTutor = (event, reason) => {	
		const tutorResponse = JSON.parse(sessionStorage.getItem('TutorResponse'));
		if (reason && (reason === "backdropClick"  || reason === "escapeKeyDown")) {
			return;
		}
		setOpenHTModal(false);
		const payload = JSON.parse(sessionStorage.getItem('StudentRequest'));
		payload['EndPoint'] = '/TutorRequest';
		payload['authorization'] = JSON.parse(Cookies.get('loginToken'))?.idToken;;
		payload['IsDecline'] = true;
		payload['IsAccept'] = false;
		payload['SessionID'] = tutorResponse?.SessionID;

		socket.emit('PTModule', JSON.stringify(payload));
		sessionStorage.removeItem("StudentRequest");
        sessionStorage.removeItem("TutorResponse");
		sessionStorage.removeItem("SessionID");
	};

    const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);

    useEffect(() => {
		if (isConnected) {
			socket?.on('responseEvent', (response) => {
				const responseData = JSON.parse(response);

				if (responseData.StatusCode === 200 && responseData.Message === 'Request send' && responseData.Data[0]) {
					const tutorResponse = responseData.Data[0];
					if (tutorResponse.StudentID.toString() === studentProfile?.ID.toString()) {
                        if (!tutorResponse?.IsDecline) {
                            const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
                            studentRequest.SessionID = tutorResponse.SessionID;
                            sessionStorage.setItem('TutorResponse', JSON.stringify(tutorResponse))
                            sessionStorage.setItem('StudentRequest', JSON.stringify(studentRequest))
                        }

						// !tutorResponse?.IsDecline && sessionStorage.setItem('TutorResponse', JSON.stringify(tutorResponse));
						if (tutorResponse.requestType.toString() === '2' && tutorResponse.IsAccept === true) {
                            sessionStorage.setItem('pathName', 'quick-call');
							setOpenHTModal(false);
							navigate('/checkout');
						} else {
							if (tutorResponse.requestType.toString() === '2' && tutorResponse.IsAccept === false) {
								setOpenHTModal(false);
                                dispatch(openMessageModal(translation?.RejectedByTutor))
							}
						}
					}
				} else if (responseData.StatusCode === 402) {
					toast(translation?.LowAmountMessage)
					setOpenHTModal(false);
				}
			});         
		}
	}, [isConnected]);

	useEffect(() => {
		if (isConnected) {
			const payload = {}
            payload["langid"] = localStorage.getItem("langId");
			// payload['DeviceID'] = sessionStorage.getItem('deviceId');
			payload['DeviceID'] = Cookies.get('deviceId');
            payload['authorization'] = JSON.parse(Cookies.get('loginToken'))?.idToken;
			socket?.emit('FavTutor', JSON.stringify(payload));
			socket?.on('responseFavTutor', (data) => {
				const response = JSON.parse(data);                
				setFavouriteTutor(response?.FavouriteTutor || {});
			})
			socket?.on("QCQuestions", (data) => {
				const response = JSON.parse(data);
                setQuestionID(response.Data.QuestionID)
				if (response?.StatusCode === 200) {
					const QuestionQCData = response?.Data
					if (QuestionQCData?.requestType == "1" && QuestionQCData?.IsDecline == false) {
						// setOpenQCModal(true);
                        setIsApiCalling(false);
                        sessionStorage.setItem('StudentRequest', JSON.stringify(response?.Data));
                        
                        const payload = {}
                        payload["langid"] = localStorage.getItem("langId");
                        // payload['DeviceID'] = sessionStorage.getItem('deviceId');
                        payload['DeviceID'] = Cookies.get('deviceId');
                        payload['authorization'] = JSON.parse(Cookies.get('loginToken'))?.idToken;
                        payload["StudentID"] = response?.Data?.StudentID;
                        payload["SubjectID"] = response?.Data?.SubjectID;
                        payload["SessionID"] = response?.Data?.QuestionID?.toString();

                        socket?.emit('GetOnlineTutor', JSON.stringify(payload));
                        
					} else if (QuestionQCData.requestType == "2" && QuestionQCData.IsAccept == true) {
                        const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
						if (parseInt(studentRequest?.QuestionID) === parseInt(QuestionQCData?.QuestionID) && QuestionQCData.IsJoin === true) {
                            sessionStorage.setItem('pathName', window.location.pathname);
							sessionStorage.setItem('QuestionID', studentRequest?.QuestionID);
							sessionStorage.setItem('TutorResponse', JSON.stringify(QuestionQCData))
							const userUid = user?.uid;
							const channelName = `channel${studentRequest?.QuestionID}`;
							generateAgoraToken(userUid, 2, channelName).then((res) => {
								localStorage.setItem("rtmToken", JSON.stringify(res.RtmToken));
								localStorage.setItem("rtcToken", JSON.stringify(res.RtcToken));
								navigate(`/quick-calls-room/${encryptData(studentRequest?.QuestionID)}`);
							});
                        } else if (parseInt(studentRequest?.QuestionID) === parseInt(QuestionQCData?.QuestionID)) {
                            setIsConecting(true);
						}
					}
				} else if (response.StatusCode === 400) {
                    setOpenQCModal(false);
                    dispatch(openMessageModal(translation?.ExceededFreeCallLimit));
				} else if (response.StatusCode === 402) {
                    setOpenQCModal(false);
                    dispatch(openMessageModal(translation?.LowAmountMessage))
				} else {
                    setOpenQCModal(false);
                }
			})
			socket?.on("DirectQCQuestion", (data) => {
				const response = JSON.parse(data);
                setQuestionID(response.Data.QuestionID)
				if (response?.StatusCode === 200) {
					const QuestionQCData = response?.Data
					if (QuestionQCData?.requestType == "1" && QuestionQCData?.IsDecline == false) {
						// setOpenQCModal(true);
                        setIsApiCalling(false);
                        sessionStorage.setItem('StudentRequest', JSON.stringify(response?.Data));
                        
                        const payload = {}
                        payload["langid"] = localStorage.getItem("langId");
                        // payload['DeviceID'] = sessionStorage.getItem('deviceId');
                        payload['DeviceID'] = Cookies.get('deviceId');
                        payload['authorization'] = JSON.parse(Cookies.get('loginToken'))?.idToken;
                        payload["StudentID"] = response?.Data?.StudentID;
                        payload["SubjectID"] = response?.Data?.SubjectID;
                        payload["SessionID"] = response?.Data?.QuestionID?.toString();

                        socket?.emit('GetOnlineTutor', JSON.stringify(payload));
                        
					} else if (QuestionQCData.requestType == "2" && QuestionQCData.IsAccept == true) {
                        const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
						if (parseInt(studentRequest?.QuestionID) === parseInt(QuestionQCData?.QuestionID) && QuestionQCData.IsJoin === true) {
                            sessionStorage.setItem('pathName', window.location.pathname);
							sessionStorage.setItem('QuestionID', studentRequest?.QuestionID);
							sessionStorage.setItem('TutorResponse', JSON.stringify(QuestionQCData))
							const userUid = user?.uid;
							const channelName = `channel${studentRequest?.QuestionID}`;
							generateAgoraToken(userUid, 2, channelName).then((res) => {
								localStorage.setItem("rtmToken", JSON.stringify(res.RtmToken));
								localStorage.setItem("rtcToken", JSON.stringify(res.RtcToken));
								navigate(`/quick-calls-room/${encryptData(studentRequest?.QuestionID)}`);
							});
                        } else if (parseInt(studentRequest?.QuestionID) === parseInt(QuestionQCData?.QuestionID)) {
                            setIsConecting(true);
						}
					}
				} else if (response.StatusCode === 400) {
                    setOpenHTModal1(false);
                    dispatch(openMessageModal(translation?.ExceededFreeCallLimit));
				} else if (response.StatusCode === 402) {
                    setOpenHTModal1(false);
                    dispatch(openMessageModal(translation?.LowAmountMessage))
				} else {
                    setOpenHTModal1(false);
                }
			})
		}

        return () => {
            socket?.off("responseFavTutor");
            socket?.off("QCQuestions");
          };
	}, [isConnected])

    useEffect(() => {
        const studentBoard = boards?.find((board) => board?.ID === studentProfile?.StudentExaminationID);
        const grades = studentBoard?.Grades?.find((grade) => grade?.ID === studentProfile?.StudentGradeID);
        const allowedTopics = grades?.topics?.filter((topic) => topic.AllowQuickCall) || [];
    
        // Check if topics need to be updated to avoid setting state unnecessarily
        if (JSON.stringify(allowedTopics) !== JSON.stringify(topics)) {
            setTopics(allowedTopics);
        }
    }, [boards, studentProfile, topics]);

    useEffect(() => {
		const handleVisibilityChange = () => {
			// if (document.visibilityState === 'visible' && !isConnected) {
			if (!isConnected) {
				console.log('awake....')
				window.location.reload();
			}
		};

         // Handle refresh 
         if (window.performance?.getEntriesByType('navigation')[0]?.type === 'reload') {
            const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));
             if (studentRequest) {
                cancelQCRequest();
             }
        }

		document.addEventListener('visibilitychange', handleVisibilityChange);
	
		// Cleanup function to remove event listener
		return () => {
		  	document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [isConnected]);

    useEffect(() => {
		return () => {
            if (file) {
                URL.revokeObjectURL(file);
            }
			let payload = {};
			payload['authorization'] = Cookies.get('loginToken') ? JSON.parse(Cookies.get('loginToken'))?.idToken : null;
			// payload['DeviceID'] = sessionStorage.getItem('deviceId');
			payload['DeviceID'] = Cookies.get('deviceId');
			socket?.emit('ClearInterval', JSON.stringify(payload));
		};
	}, []);


        useEffect(() => {
        const handlePageRefreshOrClose = (event) => {   
            // console.log("event>>",event);
            const callRequestType = sessionStorage.getItem("CallRequestType");
            const studentRequest = JSON.parse(sessionStorage.getItem('StudentRequest'));

            if (studentRequest) {

                event.preventDefault();
                const message = "Are you sure you want to reload?";
                event.returnValue = message; 

                const userConfirmed = window.confirm(message);
                console.log("userConfirmed",userConfirmed);
                
                if (!userConfirmed) {
                    event.preventDefault();

                }
            }
        
      
            
        };

        // Add tab close listener
        window.addEventListener('beforeunload', handlePageRefreshOrClose);

        // Cleanup listener on component unmount
        return () => {
            window.removeEventListener('beforeunload', handlePageRefreshOrClose);
        };
    }, []);

  return (
    <div>
    <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
    />
    <Header/>
    <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message={translation?.FileSizeMsg}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      />
       
       <Box className="quikCallBanner">
       <Box className='OuterContainer' sx={{border:'none', borderRadius:'0px'}}>
       <Box className="particalsBanner">
            <Typography variant='div' className='Partical1'></Typography>
            <Typography variant='div' className='yellowStar'>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3287 8.00239C12.4637 7.62496 11.7674 6.94205 11.3724 6.08364C10.9773 5.22523 10.9111 4.25125 11.1864 3.34713C11.2309 3.20852 11.259 3.06513 11.27 2.91993C11.2952 2.50569 11.1865 2.09435 10.9601 1.74683C10.7336 1.3993 10.4015 1.13409 10.0129 0.99046C9.62422 0.84683 9.19973 0.832424 8.80228 0.949385C8.40483 1.06635 8.05552 1.30844 7.80615 1.63982C7.72039 1.75739 7.64883 1.88469 7.59285 2.01906C7.21611 2.88569 6.53444 3.58329 5.67761 3.97905C4.82077 4.37482 3.84854 4.4411 2.94607 4.16533C2.80772 4.1207 2.66459 4.0926 2.51966 4.08158C2.10619 4.05637 1.69562 4.16527 1.34874 4.39211C1.00186 4.61895 0.737118 4.95167 0.593753 5.34102C0.450387 5.73038 0.436016 6.15565 0.552753 6.55383C0.66949 6.95201 0.911133 7.30191 1.2419 7.55175C1.35925 7.63767 1.48633 7.7094 1.62047 7.76548C2.48551 8.14292 3.18181 8.82586 3.57684 9.68426C3.97188 10.5427 4.03807 11.5166 3.76281 12.4207C3.71826 12.5594 3.69022 12.7027 3.67921 12.8479C3.65405 13.2622 3.76271 13.6735 3.98914 14.021C4.21557 14.3686 4.54771 14.6338 4.93635 14.7774C5.325 14.921 5.74948 14.9354 6.14693 14.8185C6.54438 14.7015 6.89363 14.4594 7.143 14.128C7.22876 14.0104 7.30039 13.8832 7.35637 13.7488C7.73311 12.8821 8.41477 12.1846 9.27161 11.7888C10.1284 11.3931 11.1006 11.3267 12.0031 11.6025C12.1414 11.6471 12.2846 11.6752 12.4296 11.6863C12.843 11.7115 13.2536 11.6026 13.6005 11.3758C13.9474 11.149 14.2121 10.8162 14.3555 10.4268C14.4988 10.0375 14.5132 9.61223 14.3965 9.21404C14.2797 8.81586 14.0381 8.46591 13.7073 8.21609C13.59 8.1302 13.4629 8.05848 13.3287 8.00239Z" fill="#FFB800"/>
                </svg>
            </Typography>
            <Typography variant='div' className='redStar'>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4283 8.10786C12.5633 7.73043 11.867 7.04751 11.4719 6.1891C11.0769 5.33069 11.0107 4.35672 11.286 3.45259C11.3305 3.31398 11.3586 3.17059 11.3696 3.0254C11.3948 2.61116 11.2861 2.19982 11.0597 1.8523C10.8332 1.50477 10.5011 1.23956 10.1125 1.09593C9.72382 0.952299 9.29933 0.937893 8.90188 1.05485C8.50443 1.17181 8.15516 1.41391 7.90578 1.74529C7.82003 1.86286 7.7484 1.99015 7.69242 2.12453C7.31568 2.99116 6.63402 3.68876 5.77718 4.08452C4.92034 4.48028 3.94818 4.54657 3.04571 4.2708C2.90735 4.22617 2.7642 4.19806 2.61927 4.18705C2.20579 4.16184 1.79523 4.27073 1.44835 4.49757C1.10147 4.72441 0.836727 5.05714 0.693362 5.44649C0.549996 5.83584 0.535625 6.26111 0.652362 6.65929C0.769099 7.05747 1.01074 7.40738 1.3415 7.65721C1.45886 7.74313 1.58594 7.81487 1.72008 7.87094C2.58511 8.24838 3.28141 8.93132 3.67645 9.78972C4.07148 10.6481 4.13768 11.6221 3.86242 12.5262C3.81787 12.6648 3.78979 12.8082 3.77879 12.9534C3.75362 13.3676 3.86229 13.779 4.08871 14.1265C4.31514 14.474 4.64728 14.7392 5.03592 14.8829C5.42457 15.0265 5.84905 15.0409 6.2465 14.9239C6.64396 14.807 6.99323 14.5649 7.2426 14.2335C7.32836 14.1159 7.39999 13.9886 7.45597 13.8542C7.83271 12.9876 8.51437 12.29 9.37121 11.8943C10.228 11.4985 11.2002 11.4322 12.1027 11.708C12.241 11.7526 12.3842 11.7807 12.5291 11.7917C12.9426 11.8169 13.3532 11.7081 13.7001 11.4813C14.047 11.2544 14.3117 10.9217 14.4551 10.5323C14.5985 10.1429 14.6128 9.71769 14.4961 9.3195C14.3793 8.92132 14.1377 8.57138 13.8069 8.32155C13.6895 8.23566 13.5625 8.16394 13.4283 8.10786Z" fill="#EA4435"/>
                </svg>
            </Typography>

            {/* <Typography variant='div' className='Partical2'></Typography> */}

            <Typography variant='h1'>
                {translation?.Hi} {profileInfo?.UserName}, <Typography variant='div'  > {translation?.WelcomeYasa}</Typography>
            </Typography>
            </Box>
       <Box className="particalsBanner">
            <Typography variant='div' className='Partical1'></Typography>
            <Typography variant='div' className='yellowStar'>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.3287 8.00239C12.4637 7.62496 11.7674 6.94205 11.3724 6.08364C10.9773 5.22523 10.9111 4.25125 11.1864 3.34713C11.2309 3.20852 11.259 3.06513 11.27 2.91993C11.2952 2.50569 11.1865 2.09435 10.9601 1.74683C10.7336 1.3993 10.4015 1.13409 10.0129 0.99046C9.62422 0.84683 9.19973 0.832424 8.80228 0.949385C8.40483 1.06635 8.05552 1.30844 7.80615 1.63982C7.72039 1.75739 7.64883 1.88469 7.59285 2.01906C7.21611 2.88569 6.53444 3.58329 5.67761 3.97905C4.82077 4.37482 3.84854 4.4411 2.94607 4.16533C2.80772 4.1207 2.66459 4.0926 2.51966 4.08158C2.10619 4.05637 1.69562 4.16527 1.34874 4.39211C1.00186 4.61895 0.737118 4.95167 0.593753 5.34102C0.450387 5.73038 0.436016 6.15565 0.552753 6.55383C0.66949 6.95201 0.911133 7.30191 1.2419 7.55175C1.35925 7.63767 1.48633 7.7094 1.62047 7.76548C2.48551 8.14292 3.18181 8.82586 3.57684 9.68426C3.97188 10.5427 4.03807 11.5166 3.76281 12.4207C3.71826 12.5594 3.69022 12.7027 3.67921 12.8479C3.65405 13.2622 3.76271 13.6735 3.98914 14.021C4.21557 14.3686 4.54771 14.6338 4.93635 14.7774C5.325 14.921 5.74948 14.9354 6.14693 14.8185C6.54438 14.7015 6.89363 14.4594 7.143 14.128C7.22876 14.0104 7.30039 13.8832 7.35637 13.7488C7.73311 12.8821 8.41477 12.1846 9.27161 11.7888C10.1284 11.3931 11.1006 11.3267 12.0031 11.6025C12.1414 11.6471 12.2846 11.6752 12.4296 11.6863C12.843 11.7115 13.2536 11.6026 13.6005 11.3758C13.9474 11.149 14.2121 10.8162 14.3555 10.4268C14.4988 10.0375 14.5132 9.61223 14.3965 9.21404C14.2797 8.81586 14.0381 8.46591 13.7073 8.21609C13.59 8.1302 13.4629 8.05848 13.3287 8.00239Z" fill="#FFB800"/>
                </svg>
            </Typography>
            <Typography variant='div' className='redStar'>
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.4283 8.10786C12.5633 7.73043 11.867 7.04751 11.4719 6.1891C11.0769 5.33069 11.0107 4.35672 11.286 3.45259C11.3305 3.31398 11.3586 3.17059 11.3696 3.0254C11.3948 2.61116 11.2861 2.19982 11.0597 1.8523C10.8332 1.50477 10.5011 1.23956 10.1125 1.09593C9.72382 0.952299 9.29933 0.937893 8.90188 1.05485C8.50443 1.17181 8.15516 1.41391 7.90578 1.74529C7.82003 1.86286 7.7484 1.99015 7.69242 2.12453C7.31568 2.99116 6.63402 3.68876 5.77718 4.08452C4.92034 4.48028 3.94818 4.54657 3.04571 4.2708C2.90735 4.22617 2.7642 4.19806 2.61927 4.18705C2.20579 4.16184 1.79523 4.27073 1.44835 4.49757C1.10147 4.72441 0.836727 5.05714 0.693362 5.44649C0.549996 5.83584 0.535625 6.26111 0.652362 6.65929C0.769099 7.05747 1.01074 7.40738 1.3415 7.65721C1.45886 7.74313 1.58594 7.81487 1.72008 7.87094C2.58511 8.24838 3.28141 8.93132 3.67645 9.78972C4.07148 10.6481 4.13768 11.6221 3.86242 12.5262C3.81787 12.6648 3.78979 12.8082 3.77879 12.9534C3.75362 13.3676 3.86229 13.779 4.08871 14.1265C4.31514 14.474 4.64728 14.7392 5.03592 14.8829C5.42457 15.0265 5.84905 15.0409 6.2465 14.9239C6.64396 14.807 6.99323 14.5649 7.2426 14.2335C7.32836 14.1159 7.39999 13.9886 7.45597 13.8542C7.83271 12.9876 8.51437 12.29 9.37121 11.8943C10.228 11.4985 11.2002 11.4322 12.1027 11.708C12.241 11.7526 12.3842 11.7807 12.5291 11.7917C12.9426 11.8169 13.3532 11.7081 13.7001 11.4813C14.047 11.2544 14.3117 10.9217 14.4551 10.5323C14.5985 10.1429 14.6128 9.71769 14.4961 9.3195C14.3793 8.92132 14.1377 8.57138 13.8069 8.32155C13.6895 8.23566 13.5625 8.16394 13.4283 8.10786Z" fill="#EA4435"/>
                </svg>
            </Typography>

            {/* <Typography variant='div' className='Partical2'></Typography>

            <Typography variant='h1'>
                hi jhon , <Typography variant='div'> welcome to yasa</Typography>
            </Typography> */}
            </Box>
            {/* <Typography variant='h1'>
                hi jhon , <Typography variant='div'> welcome to yasa</Typography>
            </Typography> */}
        </Box>
       </Box>
        
   

        <Box className='OuterContainer containerShape' sx={{background:'#EAF4FF', padding:'30px'}}>
            <Box className='SectionIn'>
            { !isAskNow &&
               <Box className="questionMain">
                    <Box className="question">
                        <Typography variant='h3' sx={{mb:1}}>
                            {translation?.WhatIsYourQuestion}
                        </Typography>
                    </Box>

                    {!question && imageUrl && (
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Box className="imgCrossWrap">
                                <img
                                    src={imageUrl}
                                    alt="Uploaded"
                                    style={{ width: 'auto', height: '15rem' }}
                                />
                                <button
                                    onClick={handleRemoveImage}
                                    className="remove-button"
                                >
                                    <img src={crossBtn} />
                                </button>
                            </Box>
                        </Box>
                        ) 
                    }

                    { !question && !imageUrl &&
                        <Box 
                            className="uploadImg"
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}>
                            <Button sx={{opacity:0}}
                                component="label" variant="contained"
                                startIcon={<CloudUploadIcon />}
                                >
                                <input
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={handleFileSelect}
                                />
                            </Button>
                            <Box className="uploadcontent">
                                <Typography variant='div'>
                                <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2236 13.998L12.2236 9.99805L8.22363 13.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12.2236 9.99805V18.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M20.6141 16.3875C21.5894 15.8558 22.3599 15.0144 22.804 13.9962C23.248 12.9779 23.3403 11.8408 23.0663 10.7642C22.7923 9.68769 22.1676 8.73305 21.2908 8.05099C20.4139 7.36892 19.3349 6.99828 18.2241 6.99754H16.9641C16.6614 5.82678 16.0972 4.73988 15.314 3.81854C14.5308 2.89719 13.5489 2.16539 12.4422 1.67815C11.3354 1.19091 10.1326 0.960901 8.9242 1.00542C7.71576 1.04995 6.53315 1.36784 5.46526 1.93521C4.39737 2.50257 3.47199 3.30465 2.7587 4.28112C2.04541 5.2576 1.56277 6.38308 1.34706 7.57294C1.13135 8.76279 1.18819 9.98607 1.51329 11.1508C1.8384 12.3155 2.42332 13.3914 3.22408 14.2975" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16.2236 13.998L12.2236 9.99805L8.22363 13.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </Typography>
                                <Typography>
                                    {/* drag and drop or upload documents jpg, png and svg */}
                                    {translation?.DragDrop}
                                </Typography>
                            </Box>
                        </Box>
                    }

                    { !imageUrl && !question &&
                        <Box className="orBox">
                            <Typography variant='div'>{translation?.Or}</Typography>  
                        </Box>
                    }

                    { !imageUrl &&
                        <Box className="questionMessage">
                            <textarea
                                name="Question"
                                placeholder={translation?.TypeYourQuestion}
                                onChange={OnChangeHandler}>
                            </textarea>
                        </Box>
                    }

                    {showTopics && 
                    <>
                        <Box className="divider"></Box>
                        <Box className="subjectSelect">
                            <Typography variant='h3' sx={{mb:1}}>
                                {translation?.SelectSubject}
                            </Typography>
                            <Box className="selectBtn">

                            { topics?.map((topic) => {
                                return <button
                                key={topic.ID}
                                className={selectedTopic === topic.ID ? 'cis-selected' : ''}
                                onClick={() => handleTopicClick(topic.ID, topic)}
                                >{topic.Value}</button>
                            })}
                               
                            </Box>
                        </Box>
                    </>
                    }

                    { showSubTopics && 
                        <Box className="subjectSelect">
                            <Typography variant='h3' sx={{mb:1}}>
                                {translation?.SelectChapter}
                            </Typography>
                            <Box className="selectBtn">
                                {selectedTopic &&
                                    topics?.find((topic) => topic.ID === selectedTopic)
                                        ?.SubTopics?.map((subtopic) => (
                                            <button
                                            key={subtopic.ID}
                                            className={selectedSubtopic === subtopic.ID ? 'cis-selected' : ''}
                                            onClick={() => handleSubtopicClick(subtopic.ID)}
                                            >{subtopic.Value}</button>
                                    ))}
                            </Box>
                        </Box>
                    }

                    { selectedTopic && !disableConnect && (question?.length > 10 || imageUrl) ?
                        <Box sx={{mt:3}}>
                            <button className='connectBtn'
                            onClick={() =>handleConnectWithTutor(0)}>{translation?.ConnectWithTutor}</button> 
                        </Box> : <></>
                    }

                    { question?.length > 10 && !imageUrl && !showTopics ? <Box sx={{mt:3}}>
                            <button className='connectBtn'
                            onClick={onContinuehandler}>{translation?.Continue}</button> 
                        </Box> : <></>
                    }

                    <Box className="noteBox" sx={{mt:2}}>
                        <Box className="ProfilePic">
                        <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.7656 0.433594H2.23438C1.86452 0.433594 1.50982 0.580517 1.24829 0.842043C0.986767 1.10357 0.839844 1.45827 0.839844 1.82812V16.1719C0.839844 16.5417 0.986767 16.8964 1.24829 17.158C1.50982 17.4195 1.86452 17.5664 2.23438 17.5664H3.56814C3.68124 17.5664 3.79201 17.5343 3.88757 17.4738C3.98314 17.4133 4.05958 17.3269 4.10803 17.2247C4.51162 16.3724 5.14891 15.6522 5.94577 15.1478C6.74263 14.6434 7.66631 14.3757 8.60938 14.3757C9.55244 14.3757 10.4761 14.6434 11.273 15.1478C12.0698 15.6522 12.7071 16.3724 13.1107 17.2247C13.1592 17.3269 13.2356 17.4133 13.3312 17.4738C13.4267 17.5343 13.5375 17.5664 13.6506 17.5664H19.7656C20.1355 17.5664 20.4902 17.4195 20.7517 17.158C21.0132 16.8964 21.1602 16.5417 21.1602 16.1719V1.82812C21.1602 1.45827 21.0132 1.10357 20.7517 0.842043C20.4902 0.580517 20.1355 0.433594 19.7656 0.433594ZM6.01953 10.5938C6.01953 10.0815 6.17142 9.58081 6.456 9.15491C6.74057 8.72901 7.14505 8.39707 7.61828 8.20105C8.09152 8.00503 8.61225 7.95374 9.11463 8.05367C9.61701 8.1536 10.0785 8.40026 10.4407 8.76245C10.8029 9.12465 11.0495 9.58612 11.1495 10.0885C11.2494 10.5909 11.1981 11.1116 11.0021 11.5848C10.8061 12.0581 10.4741 12.4626 10.0482 12.7471C9.62232 13.0317 9.1216 13.1836 8.60938 13.1836C7.92251 13.1836 7.26377 12.9107 6.77808 12.425C6.29239 11.9394 6.01953 11.2806 6.01953 10.5938ZM19.9648 16.1719C19.9648 16.2247 19.9439 16.2754 19.9065 16.3127C19.8691 16.3501 19.8185 16.3711 19.7656 16.3711H14.0152C13.3183 15.1202 12.2105 14.1487 10.8795 13.6209C11.5153 13.1444 11.985 12.4799 12.2221 11.7215C12.4592 10.9632 12.4516 10.1494 12.2005 9.39563C11.9494 8.64181 11.4674 7.98614 10.8228 7.52151C10.1783 7.05688 9.40392 6.80685 8.60938 6.80685C7.81483 6.80685 7.04043 7.05688 6.3959 7.52151C5.75137 7.98614 5.2694 8.64181 5.01826 9.39563C4.76713 10.1494 4.75958 10.9632 4.99667 11.7215C5.23377 12.4799 5.70349 13.1444 6.33928 13.6209C5.00822 14.1487 3.90046 15.1202 3.20357 16.3711H2.23438C2.18154 16.3711 2.13087 16.3501 2.09351 16.3127C2.05615 16.2754 2.03516 16.2247 2.03516 16.1719V1.82812C2.03516 1.77529 2.05615 1.72462 2.09351 1.68726C2.13087 1.6499 2.18154 1.62891 2.23438 1.62891H19.7656C19.8185 1.62891 19.8691 1.6499 19.9065 1.68726C19.9439 1.72462 19.9648 1.77529 19.9648 1.82812V16.1719ZM17.9727 4.21875V13.7812C17.9727 13.9398 17.9097 14.0918 17.7976 14.2039C17.6855 14.3159 17.5335 14.3789 17.375 14.3789H15.7812C15.6227 14.3789 15.4707 14.3159 15.3586 14.2039C15.2466 14.0918 15.1836 13.9398 15.1836 13.7812C15.1836 13.6227 15.2466 13.4707 15.3586 13.3586C15.4707 13.2466 15.6227 13.1836 15.7812 13.1836H16.7773V4.81641H5.22266V5.8125C5.22266 5.97101 5.15969 6.12302 5.04761 6.23511C4.93552 6.34719 4.78351 6.41016 4.625 6.41016C4.46649 6.41016 4.31448 6.34719 4.20239 6.23511C4.09031 6.12302 4.02734 5.97101 4.02734 5.8125V4.21875C4.02734 4.06024 4.09031 3.90823 4.20239 3.79614C4.31448 3.68406 4.46649 3.62109 4.625 3.62109H17.375C17.5335 3.62109 17.6855 3.68406 17.7976 3.79614C17.9097 3.90823 17.9727 4.06024 17.9727 4.21875Z" fill="#727272"/>
                        </svg>

                        </Box>
                        <Box className="contentBox">
                            <Typography>
                         <Typography variant='div'>{favouriteTutor?.TutorOnline || 0}</Typography>  {translation?.TutorHelpYou}</Typography>
                        </Box>
                    </Box>
               </Box>
            }

               { Object.keys(favouriteTutor)?.length > 0 &&
                <Box className="favouriteTutors" sx={{mt:5, mb:5}}>
                    <Box className="question">
                        <Typography variant='h3' sx={{mb:3}}>
                            {translation?.YourFavouriteTutors}
                        </Typography>
                    </Box>
                    <Swiper
                        slidesPerView={3.5}
                        spaceBetween={30}
                        slidesPerGroup={3}
                        autoplay={{delay: 2500, disableOnInteraction: false}}
                        loop={true}
                        pagination={{clickable: true}}
                        navigation={true}
                        modules={[Pagination, Navigation]}
                        breakpoints={{
                            0: {
                                slidesPerView:1.5,
                                spaceBetween:10,
                            },
                            480: {
                            slidesPerView:2.5,
                            spaceBetween:10,
                            },
                            768: {
                                slidesPerView:3.5,
                                spaceBetween:10,
                            },
                        }}
                        className="mySwiper"
                    >
                        { favouriteTutor?.FavouriteTutorList?.map((tutor) => {
                            return <SwiperSlide key={tutor?.ID}>
                                <Box className="sliderBox">
                                    <Box className="imageBox" sx={{ cursor: 'pointer' }} onClick={() => viewTutorProfile(tutor.ID)}>
                                        <img src={tutor?.ProfilePictureUrl}></img>
                                    </Box>
                                    <Box className="contentBox">
                                        <Typography variant='h3'>
                                        {tutor?.UserName}
                                        </Typography>
                                        <Box className="RatingBox" sx={{display:{xs: 'flex', justifyContent: 'start'}, my: 1 }}>
                                            <Stack spacing={2}>
                                                <Rating sx={{direction: 'ltr'}} name="half-rating-read" value={parseFloat(tutor?.Rating) || 0} precision={0.5} readOnly />
                                            </Stack>
                                        </Box> 
                                        {/* <Typography variant='h4' className="redTxt" sx={{display:{xs: 'flex', alignItems: 'center'}, direction: 'ltr'}}>
                                            {tutor?.Rating}
                                            <Typography variant='div'>
                                                <svg width="12" height="12" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 0L6.12257 3.45492H9.75528L6.81636 5.59017L7.93893 9.04508L5 6.90983L2.06107 9.04508L3.18364 5.59017L0.244718 3.45492H3.87743L5 0Z" fill="#FFB800"/>
                                                </svg>
                                            </Typography>
                                        </Typography> */}
                                        { tutor?.Topics?.length > 3 ?
                                            <Typography sx={{minHeight: '42px'}}>
                                                {translation?.Subjects} :- {`${tutor?.Topics.slice(0, 3).join(", ")} ${translation?.And} ${tutor?.Topics?.length - 3} ${translation?.More}`}
                                            </Typography> :
                                            <Typography sx={{minHeight: '42px'}}>
                                                {translation?.Subjects} :- {tutor?.Topics.join(", ")}
                                            </Typography>
                                        }
                                        <Box className="sessionBtn" sx={{mt:1}}>
                                            <button 
                                                // className='blueBtn radius4' 
                                                className={`connectStatus radius4 ${tutor?.OnlineStatusID === 1 ? 'onlineStatus' : tutor?.OnlineStatusID === 2 ? 'busyStatus' : 'offlineStatus' }`} 
                                                disabled={tutor.OnlineStatusID != 1} 
                                                onClick={() => tutor.IsProfessional ? onConnectFavTutor(tutor): askNow(tutor)}>{tutor.IsProfessional ? translation?.HireNow : translation?.AskNow}
                                            </button>
                                        </Box>
                                    </Box>
                                </Box>
                            </SwiperSlide>
                        })}
                    </Swiper>
                </Box>
                }

                { studentDashboard?.RecentCalls?.length > 0 && 
                    <Box className="filterBox" sx={{mt:5, mb:5}}>
                        <Box className="filterhead" sx={{gap:2, display:{xs: 'flex', alignItems: 'center', justifyContent:'space-between'}}}>
                            <Typography variant='h2' sx={{fontSize:'20px', color:'#0F4D92', fontWeight:'600', lineHeight:'28px', textTransform:'capitalize'}}>
                                {translation?.RecentSession}
                            </Typography>
                            <Box className="fillterDropDown" sx={{gap:2, display:{xs: 'flex', alignItems: 'center', justifyContent:'space-between'}}}>
                            { studentDashboard?.RecentCalls?.length > 4 && 
                                <Button className="borderBtn" onClick={viewSessionList}>{translation?.ViewAllSessions}</Button>
                            }
                            </Box>
                        </Box>
                    </Box>
                }


                <Box className="videoSection">
                    <Box sx={{ flexGrow: 1 }}>
                        <Grid container spacing={2}>
                        { studentDashboard?.RecentCalls && 
                            studentDashboard?.RecentCalls?.slice(0, 4)?.map((session) => {
                                return <Grid item xs={12} md={6} key={session?.ID}>
                                    <Box className="outerCard">
                                        <Box className="VideoBox">
                                            { session?.RecordedSessionURL ?
                                                <VideoThumbnail
                                                    videoUrl={session?.RecordedSessionURL}
                                                    snapshotAtTime ={20}
                                                    /> : <Box className="VideoMsg">
                                                    {translation?.VideoWillBeAvailable}
                                                </Box>
                                            }
                                        { session?.RecordedSessionURL && <Box className="playBtn" onClick={() => viewSessionDetail(session)}> 
                                        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.3861 5.24298C12.7788 6.00033 12.7788 7.99967 11.3861 8.75702L3.2393 13.1871C1.90661 13.9118 0.283854 12.9471 0.283854 11.4301L0.283854 2.56991C0.283854 1.05293 1.90661 0.0881979 3.23929 0.81289L11.3861 5.24298Z" fill="white"/>
                                        </svg>
                                        </Box> }
                                        <Box className="videoInBts" sx={{ display:{xs: 'flex', alignItems: 'center', justifyContent:'space-between'}}}>
                                            <button className='hireBtn'>{session?.Type === 'PT' ? translation?.FindTutor : session?.Type === 'QC' ? translation?.QuickCallBtn : ''}</button>
                                            {/* <button className='timerBtn'>01 : 05 min</button> */}
                                            <button className='timerBtn'>{session?.CallDuration?.replace('.', ':') || 0}</button>

                                        </Box>
                                        </Box>
                                        <Box className="contentBoxList">
                                            <Box className="TimeRankBox" sx={{ display:{xs: 'flex', alignItems: 'center', justifyContent:'space-between', minHeight: '37px'}}}>
                                                <Box className="dateTimeBox" sx={{gap:1, display:{xs: 'flex', alignItems: 'center'}}}>
                                                    <Typography variant='div'>{timeAgoDate(session?.StartDateTime)}</Typography>
                                                    {/* <Typography variant='div'>{timeAgoDate(session?.StartDateTime)}</Typography>|
                                                    <Typography variant='div'>{momentDate(session?.StartDateTime)}</Typography> */}
                                                </Box>
                                                <Box className="RatingBox">
                                                { parseFloat(session?.Ratings) ?
                                                    <Stack spacing={2}>
                                                        <Rating sx={{direction: 'ltr'}} name="half-rating-read" value={parseFloat(session?.Ratings)} precision={0.5} readOnly />
                                                    </Stack> : <Box className="cardLeft">
                                                        <Button onClick={() => handleSessionRating(session)}>{translation?.RateThisSession}</Button>
                                                    </Box>
                                                }
                                                </Box>
                                            </Box>
                                            <Box className="mathsBtn" sx={{minHeight: '31px'}}>
                                                {session?.Type === 'QC' && <button className='sky radius4'>{session?.TopicName}</button>}
                                            </Box>
                                            {session?.Notes && (
                                                <>
                                                {isHTML(session.Notes) ? (
                                                    // Render HTML if it contains valid HTML
                                                    <Typography variant='h5' sx={{ minHeight: '20px'}}>
                                                    </Typography>
                                                    ) : (
                                                    <Typography variant='h5' sx={{ minHeight: '20px'}}>
                                                        {session?.Notes?.length > 30 ?  session?.Notes.slice(0, 30) + '...' : session?.Notes}
                                                    </Typography>
                                                    )}
                                                </>
                                            )}
                                            {/* <Typography variant='h5' sx={{ minHeight: '20px'}}>
                                                {session?.Notes?.length > 30 ?  session?.Notes.slice(0, 30) + '...' : session?.Notes}
                                            </Typography> */}
                                            <Box className="sessionCard radius8" sx={{mt:1}}>
                                                <Typography variant='h5' sx={{mb:1}}>{translation?.SessionBy}</Typography>
                                                <Box className="RankInfo" sx={{gap:1.5, display:{xs: 'flex', alignItems: 'top'}}}>
                                                    <Box 
                                                        sx={{cursor: 'pointer'}}
                                                        // className={`ProfilePic ${session.OnlineStatusID === '1' ? 'add-online' : session.OnlineStatusID === '2' ? 'add-busy' : 'add-offline' }`}
                                                        className={`ProfilePic`}
                                                        onClick={() => viewTutorProfile(session?.TutorID)}>
                                                        <img src={session?.TutorProfilePicture}></img>
                                                    </Box>
                                                    <Box className="TeachInfo">
                                                        <Typography variant='h5'>{session?.TutorName}</Typography>
                                                        <Box className="RatingBox">
                                                            <Stack spacing={2}>
                                                                <Rating sx={{direction: 'ltr'}} name="half-rating-read" value={parseFloat(session?.TutorRating) || 0} precision={0.5} readOnly />
                                                            </Stack>
                                                        </Box> 
                                                    </Box>
                                                    <Button className={`favrouiteBtn ${session?.FavouriteTutor === "true" ? 'active' : ''}`} onClick={() => handleFavouriteTutor(session)} sx={{padding: '0', minWidth: '36px', maxWidth: '36px', background: 'none', marginLeft:'auto'}}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                            <circle cx="12" cy="12" r="12" fill="#D8D8D8" />
                                                            <path d="M12 4L13.7961 9.52786H19.6085L14.9062 12.9443L16.7023 18.4721L12 15.0557L7.29772 18.4721L9.09383 12.9443L4.39155 9.52786H10.2039L12 4Z" fill="white" />
                                                        </svg>
                                                    </Button>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Grid>
                            })
                         }
                        </Grid>
                    </Box>
                </Box>
                {/* <Box className="PaginationBox" sx={{ mt:4, mb:5, display:{xs: 'flex', alignItems: 'center', justifyContent:'center'}}}>
                    <Stack spacing={2}>
                        <Pagination2 count={5} variant="outlined" color="primary" />
                    </Stack>
                </Box> */}

                <Advertisement />
            </Box>
        </Box>
        <FooterSection/>

        <Dialog
            keepMounted
            open={isAskNow && !isCropImageModal && !openHTModal1}
            sx={{
                "& .MuiDialog-paper": {
                    width: "500px", // Set the width to 500px
                    maxWidth: "500px", // Prevent it from expanding beyond 500px
                },
            }}
        >
            <DialogContent className="text-center">
                <Box className="questionMain">
                    <Box className="question">
                        <Typography variant='h3' sx={{mb:1}}>
                            {translation?.WhatIsYourQuestion}
                        </Typography>
                    </Box>

                    {!question && imageUrl && (
                        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Box className="imgCrossWrap">
                                <img
                                    src={imageUrl}
                                    alt="Uploaded"
                                    style={{ width: 'auto', height: '15rem' }}
                                />
                                <button
                                    onClick={handleRemoveImage}
                                    className="remove-button"
                                >
                                    <img src={crossBtn} />
                                </button>
                            </Box>
                        </Box>
                        ) 
                    }

                    { !question && !imageUrl &&
                        <Box 
                            className="uploadImg"
                            onDragOver={handleDragOver}
                            onDrop={handleDrop}>
                            <Button sx={{opacity:0}}
                                component="label" variant="contained"
                                startIcon={<CloudUploadIcon />}
                                >
                                <input
                                    type="file"
                                    accept=".png, .jpg, .jpeg"
                                    style={{ display: 'none' }}
                                    onChange={handleFileSelect}
                                />
                            </Button>
                            <Box className="uploadcontent">
                                <Typography variant='div'>
                                <svg width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M16.2236 13.998L12.2236 9.99805L8.22363 13.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12.2236 9.99805V18.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M20.6141 16.3875C21.5894 15.8558 22.3599 15.0144 22.804 13.9962C23.248 12.9779 23.3403 11.8408 23.0663 10.7642C22.7923 9.68769 22.1676 8.73305 21.2908 8.05099C20.4139 7.36892 19.3349 6.99828 18.2241 6.99754H16.9641C16.6614 5.82678 16.0972 4.73988 15.314 3.81854C14.5308 2.89719 13.5489 2.16539 12.4422 1.67815C11.3354 1.19091 10.1326 0.960901 8.9242 1.00542C7.71576 1.04995 6.53315 1.36784 5.46526 1.93521C4.39737 2.50257 3.47199 3.30465 2.7587 4.28112C2.04541 5.2576 1.56277 6.38308 1.34706 7.57294C1.13135 8.76279 1.18819 9.98607 1.51329 11.1508C1.8384 12.3155 2.42332 13.3914 3.22408 14.2975" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M16.2236 13.998L12.2236 9.99805L8.22363 13.998" stroke="#727272" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                </Typography>
                                <Typography>
                                    {translation?.DragDrop}
                                </Typography>
                            </Box>
                        </Box>
                    }

                    { !imageUrl && !question &&
                        <Box className="orBox">
                            <Typography variant='div'>{translation?.Or}</Typography>  
                        </Box>
                    }

                    { !imageUrl &&
                        <Box className="questionMessage">
                            <textarea
                                name="Question"
                                placeholder={translation?.TypeYourQuestion}
                                onChange={OnChangeHandler}>
                            </textarea>
                        </Box>
                    }

                    {showTopics && <>
                        <Box className="divider"></Box>
                        <Box className="subjectSelect">
                            <Typography variant='h3' sx={{mb:1}}>
                                {translation?.SelectSubject}
                            </Typography>
                            <Box className="selectBtn">

                            { topics?.map((topic) => {
                                return <button
                                key={topic.ID}
                                className={selectedTopic === topic.ID ? 'cis-selected' : ''}
                                onClick={() => handleTopicClick(topic.ID, topic)}
                                >{topic.Value}</button>
                            })}
                               
                            </Box>
                        </Box>
                    </>}

                    { showSubTopics && 
                        <Box className="subjectSelect">
                            <Typography variant='h3' sx={{mb:1}}>
                                {translation?.SelectChapter}
                            </Typography>
                            <Box className="selectBtn">
                                {selectedTopic &&
                                    topics?.find((topic) => topic.ID === selectedTopic)
                                        ?.SubTopics?.map((subtopic) => (
                                            <button
                                            key={subtopic.ID}
                                            className={selectedSubtopic === subtopic.ID ? 'cis-selected' : ''}
                                            onClick={() => handleSubtopicClick(subtopic.ID)}
                                            >{subtopic.Value}</button>
                                    ))}
                            </Box>
                        </Box>
                    }

                    { selectedTopic && !disableConnect && (question?.length > 10 || imageUrl) ?
                        <Box sx={{mt:3}}>
                            <button className='connectBtn'
                            onClick={() =>handleAskNowTutor(0)}>{translation?.ConnectWithTutor}</button> 
                        </Box> : <></>
                    }

                    { question?.length > 10 && !imageUrl && !showTopics ? <Box sx={{mt:3}}>
                            <button className='connectBtn'
                            onClick={onContinuehandler}>{translation?.Continue}</button> 
                        </Box> : <></>
                    }
               </Box>
                
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <Button
                // onClick={closed}
                variant="contained"
                color="error"
                size="large"
                sx={{ px: 5 }}
                onClick={() => setIsAskNow(false)}
                >
                {translation?.QuickCancel}
                </Button>
            </DialogActions>
        </Dialog>


        <ImageCropModal isCropImageModal={isCropImageModal} translation={translation} imageToCrop={file} isApiCalling={isApiCalling}
        setCroppedImage={setFile} cancelCropImage={cancelCropImage} onSubmitCroppedImage={onSubmitCroppedImage} />
        <QuickCallModal isOpen={openQCModal} isApiCalling={isApiCalling} translation={translation} handleClose={cancelQuickCall} handleConnect={handleConnectWithTutor}  questionID={QuestionID} isConecting={isConecting} />  
        <HireTutorModal isOpen={openHTModal} studentRequest={studentRequest} translation={translation} handleClose={cancelFavTutor} />
        <AskNowTutorModal isOpen={openHTModal1} studentRequest={studentRequest} translation={translation} handleClose={cancelAskNowRequest} />
        <FeedbackModal isOpen={feedbackModal} feedback={sessionFeedBack} translation={translation} onChangeFeedback={onChangeFeedback} onSubmitFeedback={onSubmitFeedback} />    
        <MessageModal isOpen={isMessage} btnTxt={translation?.OkButton} />
    </div>
  )
}

export default QuickCall;